import request from '@/utils/request'

// 0801 获取最新版本
export function queryVersion (data) {
  return request({
    url: '/version/latest',
    method: 'post',
    data
  })
}

// 0802获取下载地址
export function getApp (data) {
  return request({
    url: '/version/path',
    method: 'post',
    data
  })
}
